export default function Game_Components() {
  return (
    <div>
      <h1>Game_Components Component</h1>
    </div>
  );
}
